module.exports = __webpack_public_path__ + "img/market-right-1.79b89d52.png";